/* eslint-disable import/prefer-default-export */
import ViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import AnalysisType, { AnalysisTypeStrings } from 'enums/AnalysisType'
import MetricCategoryItem from 'enums/MetricCategoryItem'
import MetricSeries from 'enums/MetricSeries'
import { TimelineSeries } from 'schemas/TimelineSeriesSchema'
import { getChildColor } from 'utils/MetricItemUtil'

export const MAX_MATRIXED_ITEM_COUNT = 60

const upperToLowerCamelcase = (str: string) =>
  str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
    index === 0 ? word.toLowerCase() : word.toUpperCase()
  )

export const getSeriesColor = (
  series: TimelineSeries,
  analysisType: AnalysisTypeStrings,
  viewOption?: InsightViewOptionStrings
) => {
  if (series.isChild) {
    if (series.category !== MetricCategoryItem.NONE) {
      return getChildColor(series.category!)
    }

    if (
      series.type === MetricSeries.POSITIVE_SENTIMENT ||
      series.type === MetricSeries.NEGATIVE_SENTIMENT
    ) {
      return `metricSeriesType.${upperToLowerCamelcase(series.type)}`
    }

    return getChildColor(series.type!)
  }

  switch (analysisType) {
    case AnalysisType.SW_TIMELINE_COMPARISON:
    case AnalysisType.AM_TIMELINE_COMPARISON:
      return null
    default:
      switch (viewOption) {
        case ViewOption.STAR_RATINGS:
        case ViewOption.SURVEY_SCORES:
          if (
            series.type === MetricSeries.OVERALL_STAR_RATINGS ||
            series.type === MetricSeries.OVERALL_SURVEY_SCORES
          ) {
            return `metricSeriesType.${upperToLowerCamelcase(series.type)}`
          }
          return null
        default:
          return `metricSeriesType.${upperToLowerCamelcase(series.type!)}`
      }
  }
}
